import { render, staticRenderFns } from "./customerOrder.vue?vue&type=template&id=97114adc&scoped=true"
import script from "./customerOrder.vue?vue&type=script&lang=js"
export * from "./customerOrder.vue?vue&type=script&lang=js"
import style0 from "./customerOrder.vue?vue&type=style&index=0&id=97114adc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97114adc",
  null
  
)

export default component.exports